function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.222.8h-.389V.4c0-.24-.155-.4-.389-.4-.233 0-.388.16-.388.4v.4H1.944V.4c0-.24-.155-.4-.388-.4-.234 0-.39.16-.39.4v.4H.778A.791.791 0 000 1.6v5.6c0 .44.35.8.778.8h5.444C6.65 8 7 7.64 7 7.2V1.6c0-.44-.35-.8-.778-.8zm0 6c0 .24-.155.4-.389.4H1.167c-.234 0-.39-.16-.39-.4V3.2c0-.24.156-.4.39-.4h4.666c.234 0 .39.16.39.4v3.6z",
  fill: "#333",
  fillRule: "nonzero",
  fillOpacity: 0.25
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 8
  }, props), _ref);
}

export default SvgCalendar;